import { Container } from 'components/container'
import styled from 'styled-components/macro'
import { Overlay, styleReset } from 'styles/misc'
import { mq } from 'styles/mq'
import { theme } from 'styles/theme'

export const Section = styled.div`
  position: relative;
  width: 100%;
  margin-block: 1.2rem;
  color: white;
  background: radial-gradient(
    circle at center,
    ${theme.colors.accent.secondaryLight},
    ${theme.colors.accent.secondary}
  );

  ${mq.large} {
    font-size: 1.9rem;
  }

  ${Container} {
    display: flex;
    flex-direction: column;

    ${mq.smallOnly} {
      padding: 0;
      min-height: 200vh;
      min-height: 200svh;
    }

    ${mq.medium} {
      flex-direction: row;
      justify-content: space-between;
      gap: var(--container-spacing);
      min-height: 100vh;
      min-height: 100svh;
    }
  }
`

export const TextContent = styled.div`
  align-self: center;
  max-width: 60rem;

  ${mq.smallOnly} {
    margin-top: auto;
    padding: var(--container-spacing);
  }

  ${mq.large} {
    margin-inline: auto;
  }
`

export const StyledForm = styled.form`
  --color-dark: #14130f;
  --color-gray: #333333;
  --color-light: #ececec;

  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 3rem 2rem;
  color: ${theme.colors.text};
  background: radial-gradient(circle at center, #ffd05f 0%, #ffb400 100%);

  fieldset {
    margin: 0;
  }

  ${mq.smallOnly} {
    border-top: 1.2rem solid white;
    min-height: 100vh;
    min-height: 100svh;
    margin-top: auto;
  }

  ${mq.medium} {
    width: 32rem;
    padding-block: 5rem;
    margin-left: 2rem;
  }

  ${mq.large} {
    margin-right: 11.5rem;
  }
`

export const Title = styled.h2`
  margin-top: 0;
  font-size: 2.4rem;
  font-weight: 700;

  ${mq.large} {
    font-size: 3rem;
  }
`

export const Row = styled.div`
  max-width: 68rem;
  margin-bottom: 1rem;
  font-size: 1.8rem;
  line-height: 1.3;
`

export const SubmitButton = styled.input`
  outline: 0;
  border: 0;
  border-radius: 0.8rem;
  padding: 1.8rem 4.5rem;
  margin-block: 1em;
  width: 100%;
  color: white;
  font-size: 1.4rem;
  background: ${theme.colors.text};

  &:not(:disabled) {
    cursor: pointer;
  }
`

export const Input = styled.input`
  font-weight: 400;
  outline: 0;
  background: none;
  border: 1px solid currentColor;
  border-radius: 0.8rem;
  padding: 1.5rem 1rem;
  width: 100%;
  font-size: 1.6rem;
  text-align: center;
`

export const Fieldset = styled.fieldset`
  border: 0;
  margin: 0 auto;
  padding: 0 0 0 1.4em;
  width: 100%;
  max-width: 600px;
  margin-bottom: 50px;
  font-size: 1.4rem;

  input[type='checkbox'] {
    width: 1.4em;
    margin-left: -1.4em;
  }
`

export const Consent = styled.div`
  ${Overlay}
  position: fixed;
  background: rgba(20, 19, 15, 0.9);
  color: white;
  text-align: left;
  font-size: 1.8rem;
  display: flex;
  align-items: center;
  justify-content: center;

  > div {
    width: 55vw;
    height: 37vw;
    max-height: 25vw;
    padding: 6rem;
    border: 1px solid white;
    border-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xml:space='preserve' viewBox='0 0 800 528'%3E%3Cpath fill='none' stroke='%23ececec' d='M.5 503.7V24.3L19.9.5h760.3l19.4 23.8v479.3l-19.4 23.8H19.9L.5 503.7z'/%3E%3C/svg%3E")
      200 200 / 200 200 / 1rem stretch round;
    overflow-y: auto;
  }

  p {
    margin-top: 0;
    margin-bottom: 50px;
    letter-spacing: 1px;
  }

  ${mq.ltLarge} {
    > div {
      width: 100%;
      height: 100%;
      max-height: none;
      border: 0;
      padding: 50px;
      box-sizing: border-box;
    }
  }
`

export const CloseButton = styled.button`
  ${styleReset}
  width: 35px;
  height: 35px;
  position: fixed;
  top: 30px;
  right: 30px;
  cursor: pointer;
`

export const ReadMore = styled.button`
  ${styleReset}
  cursor: pointer;
`

export const Links = styled.div`
  margin: -2rem 0 0;
  text-align: center;
  font-size: 1.4rem;

  a,
  button {
    display: inline-block;
    color: inherit;
    margin: 0 0.6em;
    line-height: 1.2;
    border-bottom: 1px solid #333;

    &:hover {
      border-bottom-color: white;
    }
  }
`
